package com.klantenstop.web.pages.manageCompany

import androidx.compose.runtime.Composable
import com.klantenstop.web.navigation.authenticatedGuard
import com.klantenstop.web.pages.manageCompany.create.CreateCompanyScreen
import com.klantenstop.web.pages.manageCompany.edit.EditCompanyScreen
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext

@Page("/bedrijven/beheren/{companyIdentifier?}")
@Composable
fun ManageCompanyPage(ctx: PageContext) = authenticatedGuard {
    val companyId = ctx.route.params["companyIdentifier"]

    if (companyId.isNullOrBlank()) {
        // No companyId in route, so we are in create flow
        CreateCompanyScreen()
    } else {
        // companyId is present in route, so we are in edit flow
        EditCompanyScreen(companyId)
    }
}
